import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import PipelineCard from "./PipelineCard";

const SortablePipelineCard = ({
  lead,
  columnSettings,
  onViewDetails,
  onContactClick,
  onMenuAction,
  bulkSelectMode = false,
  isSelected = false,
  onSelectToggle,
  isFirstColumn = false,
  isLastColumn = false,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: lead._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  // When in bulk select mode and card is selected, allow dragging
  // When in bulk select mode but not selected, disable dragging to allow click selection
  const dragProps = bulkSelectMode
    ? isSelected
      ? { ...attributes, ...listeners }
      : {}
    : { ...attributes, ...listeners };

  return (
    <div ref={setNodeRef} style={style} {...dragProps}>
      <PipelineCard
        lead={lead}
        columnSettings={columnSettings}
        onViewDetails={onViewDetails}
        onContactClick={onContactClick}
        onMenuAction={onMenuAction}
        isDragging={isDragging}
        bulkSelectMode={bulkSelectMode}
        isSelected={isSelected}
        onSelectToggle={onSelectToggle}
        isFirstColumn={isFirstColumn}
        isLastColumn={isLastColumn}
      />
    </div>
  );
};

export default SortablePipelineCard;
